import { component } from 'flightjs';
import riot from 'riot';

let modal = {
    currentModalModel: {}
};

modal.showModal = function(tagName, model) {
    if (!this.component) {
        let componentInstance;
        component(function() {
            componentInstance = this;
            this.attr = {};
        });
        this.component = componentInstance;
    }

    model.close = function() {
        this.component.trigger(document, 'ui:modal:close');
    }.bind(this);

    const payload = {
        content: '<riot-modal></riot-modal>',
        cssClass:
            'modal-default-new-style modal-background ' +
            (model.extraClass ? model.extraClass : ''),
        nonDismissible: model.nonDismissible,
        beforeShow: function() {
            const tag = riot.mount('riot-modal', tagName, { model: model });
            model.update = function() {
                tag[0].update();
            };
        }
    };
    this.component.trigger(document, 'ui:modal:open', payload);

    modal.currentModalModel = model;

    return model;
};

export default modal;
